import { Carousel } from '@77sol-ui/molecules'
import styled from 'styled-components'

export const StyledCarouselItem = styled(Carousel.Item)`
  cursor: pointer;
  border-radius: 8px;
  overflow: hidden;
`
